import Order from './Order.js'

/**
*   OrdersCollection
*
*/
class OrdersCollection {
  
  
  constructor () {
    // all the orders, indexed by id
    this.orders = {};

    this.info = {}
    
    // cart id
    this.cart_id = undefined;
    
    this.has = function (order_number) {
      return Object.keys(this.orders).indexOf("" + order_number) > -1;
    }
  }
  
  /**
  *   Add an order
  *   @WARNING => order MUST not be an order instance, we generate one here when applicable
  */
  addOrder (order) {
    if (!this.has(order.order_number)) {
      this.orders[order.order_number] = new Order(order);
    } else {
      _.extend(this.orders[order.order_number], order);
    }
    return order.cart_id;
  }
  
  addInfo (info) {
    this.info = info
    _.each(info, (item, order_number) => {
      this.addOrder({order_number: order_number})
      this.orders[order_number].addInfo(item)
    })
    // _.forEach(check, function(item, order_number) {
    //   this.addInfo
    //   this.addOrder({order_number: order_number});
    //   // store info at order level
    //   this.orders[order_number].addInfo(item);
    // }.bind(this));
  }
  
  addToOrder (order_number, lineItems) {
    if (! order_number) throw 'Order Number is mandatory';
    if (! lineItems) throw 'LineItems is mandatory';
    if (!this.orders[order_number]) {
      this.addOrder({order_number: order_number});
    }
    this.orders[order_number].addItems(lineItems)
  }
  
  getOrderById (id) {
    if (! id) throw 'id argument is mandatory';
    if (this.orders[id]) {
      return this.orders[id];
    }
    return false;
  }
  
  
  
}

export default OrdersCollection




// WEBPACK FOOTER //
// ./src/app/modules/Cart/classes/OrdersCollection.js